<template>
  <v-app>
    <v-main>
     <heads :expandonHover="expandonHover"></heads>
      <router-view :expandonHover="expandonHover"></router-view>
      
    </v-main>
  
  </v-app>
</template>

<script>
// import foot from './components/footer';
import heads from './components/header';
//import foot from './components/footer';


export default {

  name: 'App',

  components: {
    heads,
     //foot
  },

  data() {
    return {
      name: "ponsankar",
      expandonHover:false
    }
  }
};
</script>
